import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableHead, TableRow, Table,  
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;

    return (
      <div style={{ padding: '10px' }}>
        <h3><center><u>Farmers and Collectors Wise Purchase Summary Report</u></center></h3>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <Table aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell align={'center'}>Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</TableCell>
                <TableCell align={'center'}>FCC/s</TableCell>
                <TableCell align={'center'}>SKU Code</TableCell>
                <TableCell align={'center'}>SKU</TableCell>
                <TableCell align={'right'}>Purchase&nbsp;From Farmers&nbsp;(kg)</TableCell>
                <TableCell align={'right'}>Realized&nbsp;Price&nbsp;Purchased From&nbsp;Farmers&nbsp;(Rs)</TableCell>
                <TableCell align={'right'}>Total&nbsp;Purchase&nbsp;Value From&nbsp;Farmers&nbsp;(Rs)</TableCell>
                <TableCell align={'right'}>Purchase&nbsp;From Collector&nbsp;(kg)</TableCell>
                <TableCell align={'right'}>Realized&nbsp;Price&nbsp;Purchased from&nbsp;Collector&nbsp;(Rs)</TableCell>
                <TableCell align={'right'}>Total&nbsp;Purchase&nbsp;Value From&nbsp;Collector&nbsp;(Rs)</TableCell>
                <TableCell align={'right'}>Total&nbsp;Purchase Amount (Kg)</TableCell>
                <TableCell align={'right'}>Total&nbsp;Purchase Amount (Rs)</TableCell>
                <TableCell align={'right'}>Purchase&nbsp;%&nbsp;of Farmers </TableCell>
                <TableCell align={'right'}>Purchase&nbsp;%&nbsp;of Collectors</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productData.map((data, index) => (
                <TableRow key={index}>
                   <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" , whiteSpace: "nowrap" }}>
                    {data.orderDate}
                  </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.factoryName}
                  </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" , whiteSpace: "nowrap" }}>
                    {data.productCode}
                  </TableCell>
                  <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.productName}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.fnetAmount == 0 ? '-' : parseFloat(data.fnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                  {(data.realizedPrice == 0 || data.fnetAmount == 0) ? '-' : parseFloat(data.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.fpTotal == 0 ? '-' : parseFloat(data.fpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.cnetAmount == 0 ? '-' : parseFloat(data.cnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.cnetAmount == 0 || data.realizedPrice == 0 ? '-' : parseFloat(data.realizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.cpTotal == 0 ? '-' : parseFloat(data.cpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.totalKg == 0 ? '-' : parseFloat(data.totalKg).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.totalRs == 0 ? '-' : parseFloat(data.totalRs).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.fPercentage == 0 ? '-' : parseFloat(data.fPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                    {data.cPercentage == 0 ? '-' : parseFloat(data.cPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableRow>
              <TableCell align="center" colSpan={4} style={{ fontWeight: "bold" }}>Total</TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalFnetAmount == 0 ? '-' : parseFloat(totalValues.totalFnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalRealizedPrice == 0 ? '-' : parseFloat(totalValues.totalRealizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalFpTotal == 0 ? '-' : parseFloat(totalValues.totalFpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalCnetAmount == 0 ? '-' : parseFloat(totalValues.totalCnetAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalCRealizedPrice == 0 ? '-' : parseFloat(totalValues.totalCRealizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalCpTotal == 0 ? '-' : parseFloat(totalValues.totalCpTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalTotalKg == 0 ? '-' : parseFloat(totalValues.totalTotalKg).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalTotalRs == 0 ? '-' : parseFloat(totalValues.totalTotalRs).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalFPercentage == 0 ? '-' : parseFloat(totalValues.totalFPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
              <TableCell align={'right'} component="th" scope="row" style={{ fontWeight: "bold" }}>
                  {totalValues.totalCPercentage == 0 ? '-' : parseFloat(totalValues.totalCPercentage).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </TableCell>
            </TableRow> 
          </Table>
        </Box>
      </div>
    );
  }
}
